import { CookieHelper } from '~helpers/CookieHelper';

import { GoalsInterface } from './types';

declare global {
  interface Window {
    _tmr?: object[];
    gtag4?: (
      ...args: (string | number | boolean | object | undefined)[]
    ) => void;
    ym?: (...args: (string | number | boolean | object | undefined)[]) => void;
    ymId?: number;
  }
}

export const Goals: GoalsInterface = {
  gaClientID: undefined,
  tmrID: 3118070,
  updateGaClientID() {
    if (this.gaClientID || !window.gtag4) {
      return false;
    }

    const clientID = CookieHelper.getGaClientId();

    this.gaClientID = clientID;
    window.gtag4('set', 'user_properties', { client_id_ga4: `${clientID}.` });
  },
  gtag4({ event }) {
    return new Promise((resolve, reject) => {
      try {
        this.updateGaClientID();

        if (window.gtag4) {
          window.gtag4('event', event, {
            event_callback: () => {
              console.info('Gtag4 event', { event });
              resolve();
            },
          });
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  tmr({ goal }) {
    return new Promise((resolve, reject) => {
      try {
        if (window._tmr && this.tmrID) {
          window._tmr.push({
            id: this.tmrID,
            type: 'reachGoal',
            goal,
          });
          console.info('Tmr event', { goal });
          resolve();
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  ym({ event = 'reachGoal', action, category, label }) {
    return new Promise((resolve, reject) => {
      try {
        if (window.ym) {
          window.ym(
            window.ymId,
            event,
            action,
            {
              category,
              label,
            },
            () => {
              console.info('Ya Metrika event', {
                event,
                action,
                category,
                label,
              });
              resolve();
            },
          );
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};
